<template>
  <nav class="navbar navbar-white navbar-fixed-top">
    <div class="navbar-flex">
      <div>
        <a href="#"><b>Story</b></a>
      </div>
      <friend-search></friend-search>
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-controls="navbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div id="navbar" class="navbar-collapse collapse">
          <ul class="nav navbar-nav navbar-right">
            <li class="actives">
              <router-link :to="`/profile/${userId}`">Profile</router-link>
            </li>
            <li>
              <router-link to="/home">Home</router-link>
            </li>
            <li v-if="isLoggedIn"><a @click="logout">Logout</a></li>
            <li>
              <a href="#" class="nav-controller"><i class="fa fa-user"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const isLoggedIn = computed(() => {
      return store.getters["auth/isAuthenticated"];
    });
    const userId = computed(() => {
      return store.getters["auth/userId"];
    });

    const logout = () => {
      store.dispatch("auth/logout");
      router.replace("/login");
    };

    return {
      logout,
      userId,
      isLoggedIn,
    };
  },
};
</script>

<style scoped>
.navbar-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>